import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useToggle } from 'Hooks/useToggle'
import { Accordion } from 'Components/shared/accordion'
import { useDispatch, useSelector } from 'react-redux'
import { FilterSingleSelectDropdown } from 'Components/shared/singleselectdropdown'
import { useLoginStatusQuery } from 'Services/global/authentication'
import { useGetInstitutionsInfoQuery } from 'Services/global/institution'
import { Permissions } from 'Configs/userPermissions'
import { useHasPermission } from 'Hooks/useHasPermission'

import {
  selectCompetitiveCandidates,
  setCompetitiveCandidates
} from './CompetitiveCandidatesSlice'
import { Contract } from 'Services/contracts/contractsUtils'
import { VirtualizedMultiSelect } from 'Components/shared/multiselectdropdown'
import { set } from 'date-fns'

interface CompetitiveCandidatesProps {
  chosenItem: Partial<Contract>
  filterData?: any
  displayOnlyOption?: boolean
}

export const CompetitiveCandidates = ({
  chosenItem,
  filterData,
  displayOnlyOption = false,
}: CompetitiveCandidatesProps) => {
  const dispatch = useDispatch()
  const [expand, setExpand] = useToggle(false)

  const {
    values,
    selectedValues,
    label,
  } = useSelector(selectCompetitiveCandidates)

  const [isCompetitiveCandidates, setIsCompetitiveCandidates] = useState(selectedValues.length > 0 ? 'Yes' : 'No')

  const { hasPermission: canSwitchInstitution } = useHasPermission(
    Permissions.SwitchInstitution
  )
  const { data: userData } = useLoginStatusQuery()
  const { ipedId } = useParams()
  const { data } = useGetInstitutionsInfoQuery(canSwitchInstitution ? undefined : ipedId, {skip: !userData?.isLoggedIn})


  const dispatchCompetitiveCandidates =  useCallback((values: string[]) => {
    const searchableValues = values.map((institutionId: string) => {
          const institution = data?.find(
            (inst) => inst.id === institutionId
          )
          return institution
            ? `[ID ${institution.id}]  ${institution.name} - ${institution.state}`
            : institutionId
        }
    )
    dispatch(setCompetitiveCandidates(searchableValues))
  }, [])

  /** This useEffect is for setting filters in edit segment */
  useEffect(() => {
    const value = filterData?.[label]
    if (Array.isArray(value)) {
      const searchableValues = value.map((institutionId: string) => {
          const institution = data?.find(
            (inst) => inst.id === institutionId
          )
          return institution
            ? `[ID ${institution.id}]  ${institution.name} - ${institution.state}`
            : institutionId
        }
    )
      dispatch(
        setCompetitiveCandidates(searchableValues)
      )
      setIsCompetitiveCandidates(
        searchableValues.length > 0 ? 'Yes' : 'No'
      )
    } else {
      dispatch(setCompetitiveCandidates())
    }
  }, [filterData])



  return (
    <Accordion
      setExpand={setExpand}
      expand={expand}
      title='COMPETITIVE PROSPECTS'
      disabled={chosenItem?.id ? false : true}
    >
      <FilterSingleSelectDropdown
        label='Competitive Prospects'
        values={['Yes', 'No']}
        value={isCompetitiveCandidates}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          const chosenValue = e.target.value
          setIsCompetitiveCandidates(chosenValue)
          if (chosenValue === 'No') {
            dispatchCompetitiveCandidates([])
          }
        }}
      />
      {isCompetitiveCandidates === 'Yes' && (
        <div style={{ marginTop: '16px', marginLeft: '10px' }}>
          <VirtualizedMultiSelect
            label={'Competitor Institutions'}
            counterLabel={'Institutions'}
            values={data?.map(
              (univ) => `[ID ${univ.id}]  ${univ.name} - ${univ.state}`
            )}
            selectedValues={selectedValues.filter(
              (value) => value !== 'Any')}
            initialSelectedValues={selectedValues.filter(
              (value) => value !== 'Any')}
            setSelectedValues={dispatchCompetitiveCandidates}
            selectAll={false}
          />
        </div>
      )}
    </Accordion>
  )
}
